import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequestWithApiKey, postRequestWithApiKey } from "../../services/API";

const DEEPLINK_GET_VERIFICATION_CODE = "deepLinkGetVerificationCode";
const DEEPLINK_CHECK_STATUS = "deepLinkCheckStatus";

export const checkDeepLinkStstus = createAsyncThunk(
  DEEPLINK_CHECK_STATUS,
  async ({ language }) => {
    try {
      // Use API key for deep link status check (public endpoint)
      let deepLinkStstusResult = await getRequestWithApiKey(language, "deepLink");
      return deepLinkStstusResult;
    } catch (error) {
      return JSON.parse(error.message);
    }
  }
);

export const getDeepLinkVerificationCode = createAsyncThunk(
  DEEPLINK_GET_VERIFICATION_CODE,
  async ({ language }) => {
    try {
      // Use API key for deep link verification code (public endpoint)
      let deepLinkVerificationCodeResult = await postRequestWithApiKey(
        language,
        "deepLink",
        {},
        true // custom toast
      );
      return deepLinkVerificationCodeResult;
    } catch (error) {
      return JSON.parse(error.message);
    }
  }
);
